(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["macade-autoslider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('macade-auto-slider')) {
    class MacadeAutoSlider extends HTMLElement {
      connectedCallback() {
        // Continuous mode is pure CSS; only "slide by slide" needs JavaScript.
        if (this.dataset.motion !== 'step') return;

        this.track = this.querySelector('.macade-slider__track');
        if (!this.track || this.track.children.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.paused = false;
        this.moving = false;

        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => (this.paused = true));
          this.addEventListener('mouseleave', () => (this.paused = false));
          this.addEventListener('focusin', () => (this.paused = true));
          this.addEventListener('focusout', () => (this.paused = false));
        }

        // Theme editor: hold still while a slide is selected
        this.addEventListener('shopify:block:select', () => (this.paused = true));
        this.addEventListener('shopify:block:deselect', () => (this.paused = false));

        const seconds = parseFloat(this.dataset.speed) || 4;
        this.timer = setInterval(() => this.next(), seconds * 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      next() {
        if (this.paused || this.moving || document.hidden) return;

        const track = this.track;
        const first = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(first).marginRight) || 0;
        const step = first.getBoundingClientRect().width + gap;

        this.moving = true;
        track.style.transition = 'transform 700ms ease';
        track.style.transform = `translateX(${-step}px)`;

        let finished = false;
        const done = (event) => {
          if (finished || (event && event.target !== track)) return;
          finished = true;
          track.removeEventListener('transitionend', done);

          // Move the card that just left to the end of the row and reset,
          // so the row never runs out: the first card comes back after the last.
          track.style.transition = 'none';
          track.appendChild(first);
          track.style.transform = 'translateX(0)';
          void track.offsetWidth; // apply the reset before the next move

          this.moving = false;
        };

        track.addEventListener('transitionend', done);
        setTimeout(done, 1000); // safety net if transitionend doesn't fire
      }
    }

    customElements.define('macade-auto-slider', MacadeAutoSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
